import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";

const Logo = (props) => {
  return(
    <GatsbyImage image={props.id.gatsbyImageData} alt="" />
  )
}

export default Logo;